import styled from 'styled-components'

export default styled('button')`
  display: flex;
  align-items: center;
  background-color: #FAFBFD;
  border: 1px solid rgba(46, 56, 76, 0.37);
  border-radius: 5px;
  color: ${props => props.theme.palette.textColor};
  cursor: pointer;
  font-size: 14px;
  height: 38px;
  outline: none;
  padding: 0 10px;
  transition: ${props => props.theme.transition};
  margin-left: ${props => props.right ? 'auto' : '0'};
  &:hover {
    background-color: ${props => props.theme.palette.purpleColor};
    color: white;
  }
  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`
